export enum containerNames {
    BODY = 'body',
    BETSLIP = 'betslip',
    DROPDOWN = 'dropdown',
}

interface IItem {
    name: containerNames;
    height: number;
}

const EXTRA_PADDING = 8;

export class HeightManager {
    private container = <IItem[]>[];

    addOrUpdate(item: IItem): void {
        const index = this.container.findIndex((exItem) => exItem.name === item.name);

        if (index !== -1) {
            this.dropdownHandler(item);
            this.container[index] = item;
        } else {
            this.container.push(item);
        }
    }

    remove(itemName: containerNames): void {
        const index = this.container.findIndex((exItem) => exItem.name === itemName);

        if (index !== -1) {
            this.container.splice(index, 1);
        }
    }

    getBiggestHeight(): number {
        return (
            this.container.reduce((max, item) => (max > item.height ? max : item.height), 0) +
            EXTRA_PADDING
        );
    }

    private dropdownHandler(item: IItem): void {
        const subscriptionDropdownIndex = this.container.findIndex(
            (exItem) => exItem.name === containerNames.DROPDOWN,
        );
        const itemIndex = this.container.findIndex((exItem) => exItem.name === item.name);

        if (subscriptionDropdownIndex !== -1 && itemIndex !== -1) {
            this.container[subscriptionDropdownIndex].height +=
                item.height - this.container[itemIndex].height;
        }
    }
}
